/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoadmapResourceRowDto } from './RoadmapResourceRowDto';
import {
    RoadmapResourceRowDtoFromJSON,
    RoadmapResourceRowDtoFromJSONTyped,
    RoadmapResourceRowDtoToJSON,
    RoadmapResourceRowDtoToJSONTyped,
} from './RoadmapResourceRowDto';

/**
 * 
 * @export
 * @interface RoadmapResourceBandsDto
 */
export interface RoadmapResourceBandsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof RoadmapResourceBandsDto
     */
    laborHoursLogged?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof RoadmapResourceBandsDto
     */
    laborHoursCapacity?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof RoadmapResourceBandsDto
     */
    budgetPlannedProration?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof RoadmapResourceBandsDto
     */
    budgetSpendProration?: Array<number>;
    /**
     * 
     * @type {Array<RoadmapResourceRowDto>}
     * @memberof RoadmapResourceBandsDto
     */
    resourceRows?: Array<RoadmapResourceRowDto>;
}

/**
 * Check if a given object implements the RoadmapResourceBandsDto interface.
 */
export function instanceOfRoadmapResourceBandsDto(value: object): value is RoadmapResourceBandsDto {
    return true;
}

export function RoadmapResourceBandsDtoFromJSON(json: any): RoadmapResourceBandsDto {
    return RoadmapResourceBandsDtoFromJSONTyped(json, false);
}

export function RoadmapResourceBandsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoadmapResourceBandsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'laborHoursLogged': json['laborHoursLogged'] == null ? undefined : json['laborHoursLogged'],
        'laborHoursCapacity': json['laborHoursCapacity'] == null ? undefined : json['laborHoursCapacity'],
        'budgetPlannedProration': json['budgetPlannedProration'] == null ? undefined : json['budgetPlannedProration'],
        'budgetSpendProration': json['budgetSpendProration'] == null ? undefined : json['budgetSpendProration'],
        'resourceRows': json['resourceRows'] == null ? undefined : ((json['resourceRows'] as Array<any>).map(RoadmapResourceRowDtoFromJSON)),
    };
}

export function RoadmapResourceBandsDtoToJSON(json: any): RoadmapResourceBandsDto {
    return RoadmapResourceBandsDtoToJSONTyped(json, false);
}

export function RoadmapResourceBandsDtoToJSONTyped(value?: RoadmapResourceBandsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'laborHoursLogged': value['laborHoursLogged'],
        'laborHoursCapacity': value['laborHoursCapacity'],
        'budgetPlannedProration': value['budgetPlannedProration'],
        'budgetSpendProration': value['budgetSpendProration'],
        'resourceRows': value['resourceRows'] == null ? undefined : ((value['resourceRows'] as Array<any>).map(RoadmapResourceRowDtoToJSON)),
    };
}

